import { getSupportPortalConfigApi } from './api'
export const state = {
  config: {},
}

export const getters = {
  allowRegistration(state) {
    return state.config.allowSelfRegistration
  },
  allowGuestToCreateIncident(state) {
    return state.config.allowGuestToReportRequest
  },
  allowGuestToRequestForService(state) {
    return state.config.allowGuestRequestersToRequestForService
  },
  showRelatedKnowledge(state) {
    return state.config.showRelatedKnowledge
  },
  allowToLinkAsset(state) {
    return state.config.allowToLinkAsset
  },
  autoLinkRequesterAsset(state) {
    return state.config.autoLinkRequesterAsset
  },
  autoLinkRequesterCi(state) {
    return state.config.autoLinkRequesterCi
  },
  allowToLinkOthersAsset(state) {
    return state.config.allowToLinkOthersAsset
  },
  allowToLinkOthersCi(state) {
    return state.config.allowToLinkOthersCi
  },
  allowToLinkCi(state) {
    return state.config.allowToLinkCi
  },
  allowToReopenClosedReq(state) {
    return state.config.allowToReopenClosedReq
  },
  allowToCloseReq(state) {
    return state.config.allowToCloseReq
  },
  closedGraceTimeType(state) {
    return state.config.closedGraceTimeType
  },
  closedGraceTime(state) {
    return state.config.closedGraceTime
  },
  allowToReopenResolvedReq(state) {
    return state.config.allowToReopenResolvedReq
  },
  resolvedGraceTimeType(state) {
    return state.config.resolvedGraceTimeType
  },
  resolvedGraceTime(state) {
    return state.config.resolvedGraceTime
  },
  allowReqToAccessMyAsset(state) {
    return state.config.allowReqToAccessMyAsset
  },
  allowReqToAccessMyCi(state) {
    return state.config.allowReqToAccessMyCi
  },
  allowRequesterToViewBarcodeAndQRCode(state) {
    return state.config.allowRequesterToViewBarcodeAndQRCode
  },
  allowRequesterToAccessKB(state) {
    return state.config.allowRequesterToAccessKB
  },
  allowRequesterToAccessServiceRequest(state) {
    return state.config.allowRequesterToAccessServiceRequest
  },
  allowRequesterToAccessMyApprovals(state) {
    return state.config.allowRequesterToAccessMyApprovals
  },
  allowRequesterToAccessSolution(state) {
    return state.config.allowRequesterToAccessSolution
  },
  allowRequesterToSubmitFeedback(state) {
    return state.config.allowRequesterToSubmitFeedback
  },
  allowRequesterToAccestTicketApprovalTab(state) {
    return state.config.allowRequesterToAccestTicketApprovalTab
  },
  selfServiceSetting(state) {
    return state.config.selfServiceSetting
  },
  allowReqToAccessMyChanges(state) {
    return state.config.allowReqToAccessMyChanges
  },
  allowRequesterToCreateRequestBehalfOfOtherRequester(state) {
    return state.config.allowRequesterToCreateRequestBehalfOfOtherRequester
  },
  allowRequesterToCreateIncidents(state) {
    return state.config.allowRequesterToCreateIncidents
  },
  allowRequesterToCreateIncidentBehalfOfOtherRequester(state) {
    return state.config.allowRequesterToCreateIncidentBehalfOfOtherRequester
  },
  allowRequesterToViewAuditTrail(state) {
    return state.config.allowRequesterToViewAuditTrail
  },
  mandateCommentToReopenRequest(state) {
    return state.config.mandateCommentToReopenRequest
  },
  allowRequestDueBy(state) {
    return state.config.allowRequestDueBy
  },
}

export const mutations = {
  SET_CONFIG(state, payload) {
    state.config = payload
  },
}

export const actions = {
  init({ dispatch }) {
    dispatch('fetch')
  },

  fetch({ commit }, params) {
    return getSupportPortalConfigApi(params).then((data) => {
      commit('SET_CONFIG', data)
      return data
    })
  },

  /**
   * destroy all states when user is logged out
   */
  destroy({ commit }) {
    // perform state clean up here when user is logged out
  },
}
